<template>
  <div class="slider-options">
    <div>
      <input id="minInput" :placeholder="$t('maintenance.min')" type="number" name="text" class="inputSlider" v-model="model.data.min">
    </div>
    <div>
      <input id="maxInput" :placeholder="$t('maintenance.max')" type="number" name="text" class="inputSlider" v-model="model.data.max">
    </div>
    <div>
      <input id="stepInput" :placeholder="$t('maintenance.increment')" type="number" name="text" class="inputSlider" v-model="model.data.step">
    </div>

    <p class="preview-label">{{ $t('maintenance.preview') }}:</p>

    <div class="range-container">
      <input type="range" :min="model.data.min" :max="model.data.max" :step="model.data.step" :key="version"
        v-model="value" />
      <span class="preview-value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
const TYPE = "slider";
const MODEL = {
  data: {
    min: 0,
    max: 10,
    step: 1,
    valid: true,
  },
};

export default {
  props: {
    data: Object,
    config: Object,
  },
  data() {
    return {
      version: 1,
      value: 0,
      model: MODEL,
    };
  },
  created() {
    const isDataEmpty = JSON.stringify(this.data.data) === "{}";
    this.model = this.data;

    if (isDataEmpty) {
      this.model = MODEL;
    } else if (!isDataEmpty && TYPE !== this.config.type) {
      this.model = MODEL;
    }
  },
  watch: {
    model: {
      handler(val) {
        this.version += 1;
        this.$emit("update:data", val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 10px;
  border-radius: 8px;
  margin: auto;
}

.user-label {
  margin-right: 10px;
  font-weight: bold;
}

.inputSlider {
  padding: .4rem;
  border-radius: 4px;
  border: .1rem solid #1b3d5e;
  outline: none;
}
.preview-label {
  margin-top: 15px;
  font-weight: bold;
}
.range-container {
  display: flex;
  align-items: center;

  input[type=range]{
    flex: 1;
    margin-right: 10px;
    accent-color: #1b3d5e;
  }
  .preview-value {
    font-weight: bold;
  }
}
</style>
